module.exports = __webpack_public_path__ + "img/chain-link2.d08f8543.svg";